import * as types from '../types.js';

export default {

	html: `
		<style>
			#order.form.io-order-form {
				box-sizing: border-box;
				max-width: min(96vw, 56rem);
				width: 100%;
				min-width: 0;
			}
			#order.io-order-form .io-section-title {
				font-size: 0.75rem;
				font-weight: 600;
				letter-spacing: 0.02em;
				text-transform: uppercase;
				color: var(--color-muted, #555);
				margin: 0 0 0.4rem 0;
				grid-column: 1 / -1;
			}
			#order.io-order-form .io-grid {
				display: grid;
				grid-template-columns: repeat(4, minmax(0, 1fr));
				gap: 0.5rem 0.85rem;
				margin-bottom: 0.85rem;
				align-items: start;
			}
			#order.io-order-form .io-grid label,
			#order.io-order-form .io-grid > span {
				display: block;
				min-width: 0;
				margin-right: 0 !important;
				margin-bottom: 0 !important;
			}
			#order.io-order-form .io-grid > span > label {
				display: flex;
				flex-direction: column;
				align-items: stretch;
				min-width: 0;
				margin: 0 !important;
			}
			#order.io-order-form .io-grid label.io-field--check {
				flex-direction: row;
				flex-wrap: wrap;
				align-items: center;
				gap: 0.35rem 0.5rem;
			}
			#order.io-order-form .io-grid label.io-field--check input[type="checkbox"] {
				margin: 0;
				width: auto;
				display: inline-block;
			}
			#order.io-order-form .io-span-2 { grid-column: span 2; }
			#order.io-order-form .io-span-full { grid-column: 1 / -1; }
			#order.io-order-form .input-order-items-scroll {
				width: 100%;
				overflow-x: auto;
				margin-bottom: 0.35rem;
			}
			#order.io-order-form .input-order-items-scroll table {
				width: 100%;
				table-layout: fixed;
				border-collapse: collapse;
			}
			#order.io-order-form .input-order-items-scroll th {
				font-size: 0.82rem;
				text-align: left;
				padding: 0.35rem 0.25rem 0.2rem 0.25rem;
				border-bottom: 1px solid var(--color-border, #ccc);
				vertical-align: bottom;
			}
			#order.io-order-form .input-order-items-scroll th.tar { text-align: right; }
			#order.io-order-form .input-order-items-scroll td {
				padding: 0.25rem;
				vertical-align: middle;
			}
			#order.io-order-form .input-order-items-scroll .io-col-chk { width: 2.25rem; }
			#order.io-order-form .input-order-items-scroll .io-col-product { width: auto; }
			#order.io-order-form .input-order-items-scroll .io-col-unit { width: 9rem; }
			#order.io-order-form .input-order-items-scroll .io-col-qty { width: 6.5rem; }
			#order.io-order-form .input-order-items-scroll .io-col-price { width: 7.5rem; }
			#order.io-order-form .product,
			#order.io-order-form .unit,
			#order.io-order-form .quantity,
			#order.io-order-form .price {
				width: 100% !important;
				max-width: none !important;
				min-width: 0 !important;
				box-sizing: border-box;
			}
			#order.io-order-form .quantity,
			#order.io-order-form .price { text-align: right; }
			#order.io-order-form #freight_value,
			#order.io-order-form #discount { text-align: right; }
			#order.io-order-form label.notes {
				display: flex;
				flex-direction: column;
				width: 100%;
				margin: 0.5rem 0 0 0 !important;
			}
			#order.io-order-form label.notes textarea {
				width: 100%;
				box-sizing: border-box;
			}
			#order.io-order-form .io-footer {
				display: flex;
				justify-content: space-between;
				align-items: center;
				width: 100%;
				margin-top: 0.75rem;
				padding-top: 0.75rem;
				border-top: 1px solid var(--color-border, #ccc);
				gap: 0.75rem;
				flex-wrap: wrap;
			}
			#order.io-order-form .io-footer .button { min-width: 5.5rem; }
		</style>
		<form id="order" class="form io-order-form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="suppliers">
			</datalist>
			<datalist id="customers">
			</datalist>
			<datalist id="carriers">
			</datalist>
			<datalist id="programs">
			</datalist>
			<datalist id="receipt_types">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="units">
			</datalist>
			<datalist id="users">
			</datalist>
			<div class="io-grid">
				<div class="io-section-title">Identificação</div>
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do pedido">Pedido
					<input id="id" type="text" disabled>
				</label>
				<label title="Código de referência externa">Referência
					<input id="reference" type="text">
				</label>
				<label title="Este pedido é uma devolução?" class="io-field--check">Devolução
					<input id="is_return" type="checkbox">
				</label>
				<label title="Data e hora de criação do pedido">Data criação
					<input id="created_on" type="text" disabled>
				</label>
				<label title="Usuário criador do pedido">Criado por
					<input id="created_by" type="text" list="users" disabled>
				</label>
				<label title="Data e hora de alteração do pedido">Data alteração
					<input id="updated_on" type="text" disabled>
				</label>
				<label title="Último usuário a alterar o pedido">Alterado por
					<input id="updated_by" type="text" list="users" disabled>
				</label>
			</div>
			<div class="io-grid">
				<div class="io-section-title">Fornecedor / logística</div>
				<span id="wrap_supplier_party" class="io-span-2">
					<label title="Fornecedor do pedido">Fornecedor<sup>*</sup>
						<input id="supplier_id" type="text" list="suppliers" required>
					</label>
				</span>
				<span id="wrap_customer_party" class="io-span-2" style="display:none">
					<label title="Cliente que devolve (devolução)">Cliente (devolução)<sup>*</sup>
						<input id="customer_id" type="text" list="customers">
					</label>
				</span>
				<label title="Transportador do pedido">Transportador
					<input id="carrier_id" type="text" list="carriers">
				</label>
				<label title="Programa sugerido para a entrada">Programa
					<input id="program_id" type="text" list="programs">
				</label>
				<label title="Número do empenho (Ano + NE + número, ex.: 2025NE02173)">Nº empenho
					<input id="empenho_number" type="text" placeholder="2025NE02173" maxlength="32">
				</label>
				<label title="Tipo de recebimento (cadastro Tipos de Recebimento)" class="io-span-2">Tipo recebimento
					<input id="receipt_type_id" type="text" list="receipt_types">
				</label>
			</div>
			<div class="io-grid">
				<div class="io-section-title">Frete e status</div>
				<label title="Tipo de frete">Tipo frete
					<input id="freight_type" type="text" list="freight_types">
				</label>
				<label title="Valor do frete">Valor frete
					<input id="freight_value" type="text">
				</label>
				<label title="Desconto sobre o valor do pedido">% desconto
					<input id="discount" type="text">
				</label>
				<label title="Status do pedido" class="io-span-full">Status<sup>*</sup>
					<input id="status" type="text" list="order_status" value="10" required>
				</label>
			</div>
			<p class="io-section-title" style="margin-top:0.25rem;">Itens do pedido</p>
			<div class="input-order-items-scroll">
				<table>
					<colgroup>
						<col class="io-col-chk">
						<col class="io-col-product">
						<col class="io-col-unit">
						<col class="io-col-qty">
						<col class="io-col-price">
					</colgroup>
					<thead>
						<tr>
							<th></th>
							<th>Produto<sup>*</sup></th>
							<th>Unidade<sup>*</sup></th>
							<th class="tar">Qtde<sup>*</sup></th>
							<th class="tar">Preço unit.<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Produto">
								<input id="product_id-0" class="product" type="text" list="products" required>
							</td>
							<td title="Unidade de venda">
								<input id="unit_id-0" class="unit" type="text" list="units" required>
							</td>
							<td title="Quantidade">
								<input id="quantity-0" class="quantity" type="text" required>
							</td>
							<td title="Preço unitário do produto">
								<input id="unit_price-0" class="price" type="text" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<label class="notes" title="Observações sobre o pedido">Observações
				<textarea id="notes" rows="3"></textarea>
			</label>
			<div class="io-footer">
				<span class="io-footer-tools">
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de seleção">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conteúdo das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span class="io-footer-actions">
					<button class='bn_Escape button' type="button">Fechar</button>
					<button class='bn_Enter button' type="submit">Salvar</button>
				</span>
			</div>
		</form>
	`,

		form: 
	{
		selector: '#order',
		partyVisibilitySync(formRoot)
		{
			if (!formRoot) return;
			const ret = formRoot.querySelector('#is_return');
			const ws = formRoot.querySelector('#wrap_supplier_party');
			const wc = formRoot.querySelector('#wrap_customer_party');
			const sup = formRoot.querySelector('#supplier_id');
			const cust = formRoot.querySelector('#customer_id');
			const on = !!(ret && ret.checked);
			if (ws) ws.style.display = on ? 'none' : '';
			if (wc) wc.style.display = on ? '' : 'none';
			if (sup) sup.required = !on;
			if (cust) cust.required = on;
		},
		afterEditSetValues(fs)
		{
			const root = fs?.dialog?.getNode()?.querySelector(this.selector);
			this.partyVisibilitySync(root);
		},
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			formset.loadList('#users', 'users');
			formset.loadList('#programs', 'programs', { labels: ['name'], value: 'id' });
			formset.loadList('#receipt_types', 'receipt_types', { labels: ['code', 'description'], value: 'id' });
			Object.getPrototypeOf(this).init.call(this);
			const root = document.querySelector(this.selector);
			if (root)
			{
				const ret = root.querySelector('#is_return');
				const sup = root.querySelector('#supplier_id');
				const cust = root.querySelector('#customer_id');
				const sync = () =>
				{
					const on = !!(ret && ret.checked);
					this.partyVisibilitySync(root);
					if (on && sup) sup.value = '';
					if (!on && cust) cust.value = '';
				};
				if (ret)
					ret.addEventListener('change', sync);
				this.partyVisibilitySync(root);
			}
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#reference' }, types: [types.caps()] },
		{ properties: { selector: '#created_on' }, types: [types.datetime()] },
		{ properties: { selector: '#created_by' }, types: [types.datalist()] },
		{ properties: { selector: '#updated_on' }, types: [types.datetime()] },
		{ properties: { selector: '#updated_by' }, types: [types.datalist()] },
		{ properties: { selector: '#supplier_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('suppliers', { labels: ['cnpj', 'nick'] })] },
		{ properties: { selector: '#customer_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('customers', { labels: ['cnpj', 'nick'] })] },
		{ properties: { selector: '#carrier_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('carriers', { labels: ['nick'] })] },
		{ properties: { selector: '#program_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('programs', { labels: ['name'] })] },
		{ properties: { selector: '#empenho_number' }, types: [types.caps(), types.empenho()] },
		{ properties: { selector: '#receipt_type_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('receipt_types', { labels: ['code', 'description'] })] },
		{ properties: { selector: '#freight_type' }, types: [types.opt_freight_type(), types.datalist()] },
		{ properties: { selector: '#freight_value' }, types: [types.number(2)] },
		{ properties: { selector: '#discount' }, types: [types.number(2)] },
		{ properties: { selector: '#notes' }, types: [types.textarea()] },
		{ properties: { selector: '#is_return' }, types: [types.checkbox()] },
		{ properties: { selector: '#status' }, types: [types.opt_input_order_status(), types.datalist()] },
		{ properties: { selector: '#checkbox-0' }, types: [types.checkbox()] },
		{ properties: { selector: '#product_id-0' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('products', { labels: ['sku', 'name'], filter: r => !r.is_disabled })] },
		{ properties: { selector: '#unit_id-0' }, types: [types.pubsub(), types.datalist(), types.observer(['company_id', 'product_id-0']), types.obs_unit(1)] },
		{ properties: { selector: '#quantity-0' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#unit_price-0' }, types: [types.number(2)] },
	]

};

